module.exports = __webpack_public_path__ + "media/images/athletes/3072-cc8d6f1489c31d70ec9f382ffecc1934.png";